module.exports = __webpack_public_path__ + "img/9788957692226.405ec92c.jpg";